import React,{useEffect, useState} from "react";
import Image from "../Images/Sahil_14.png";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Email";
import "../index.css";
function Avatar() {
  const d = ["Web Developer","A Programmer","A Tech Enthusiast"];
  const [i,setI] = useState(0);
  const [desc,setDesc] = useState(d[i]);
  
  useEffect(() => {
    const f = () => {
    let ind = i;
    if(ind > 1){
      setI(0);
      setDesc(d[0]);
    }
    else{
      setI( prev => prev + 1);
      ind = ind + 1;
      setDesc(d[ind]);
    }
    // console.log(ind);
    
  };
    setTimeout(() => {
      f();
    },5000);
  },[i]);
  

  return (
    <div className="flex mt-28 md:mt-20 md:p-20 lg:p-28 justify-center flex-col lg:flex-row">
      <div className="text-center flex justify-center p-8 md:p-10">
        <img
          src={Image}
          className="avatar rounded-full mx-auto"
          alt="My_Img"
        />
      </div>
      <div className="p-14 md:p-24 md:mt-5 lg:mt-7 text">
        <p className="text-2xl md:text-4xl text-slate-700 dark:text-slate-300 text-center m-2 transition-all ease-linear duration-200">
          Hello, I'm
        </p>
        <h2 className="text-4xl md:text-7xl text-transparent bg-clip-text bg-gradient-to-br from-sky-700 via-sky-600 to-sky-700 dark:from-sky-400 dark:via-sky-600 dark:to-sky-400 text-center m-1 md:m-3 transition-all ease-linear duration-200">
          Sahil Dhoot
        </h2>
        <h5 className="text-3xl md:text-5xl text-black/80 dark:text-white/90 text-center m-2 mb-5 transition-all ease-linear duration-200">
          {desc}
        </h5>
        {/* <div className="flex justify-evenly">
          <a
            className="hover:bg-gradient-to-r from-sky-500 to-sky-700  rounded-full  dark:bg-white/90"
            href="https://www.github.com/Sahil-2904"
          >
            <GitHubIcon class="social" />
          </a>
          <a
            className="hover:bg-gradient-to-r from-sky-500 to-sky-700 rounded-full dark:bg-white/90"
            href="https://linkedin.com/in/sahil-dhoot-6a7282225"
          >
            <LinkedInIcon class="social" />
          </a>
          <a
            className="hover:bg-gradient-to-r from-sky-500 to-sky-700 rounded-full dark:bg-white/90"
            href="mailto:sahildhoot.29@gmail.com"
          >
            <MailIcon class="social" style={{color:"white"}} />
          </a>
        </div> */}
      </div>
    </div>
  );
}

export default Avatar;
